import { Now, PlainDateTime } from "../temporal";
import { parsePlainDateTime } from "./parse";
import { PlainAdapterCommon } from "./PlainAdapterCommon";
export class PlainDateTimeAdapter extends PlainAdapterCommon {
    constructor() {
        super(...arguments);
        this.lib = "PlainDateTimeAdapter";
    }
    date(value) {
        if (value === null) {
            return null;
        }
        if (value === undefined) {
            return Now.plainDateTimeISO();
        }
        if (value instanceof PlainDateTime) {
            return value;
        }
        if (typeof value === "string") {
            try {
                return PlainDateTime.from(value, { overflow: "reject" });
            }
            catch (error) {
                return this.parse(value, this.formats.shortDate);
            }
        }
        console.error("Unexpected value", value);
        return null;
    }
    toJsDate(value) {
        return new Date(value.year, value.month - 1, value.day, value.hour, value.minute, value.second, value.millisecond);
    }
    parseISO(isString) {
        return PlainDateTime.from(isString);
    }
    parse(value, format) {
        try {
            return parsePlainDateTime(value, format);
        }
        catch (error) {
            console.warn("Could not parse", { value, format });
        }
        return null;
    }
    isValid(value) {
        return this.date(value) != null;
    }
    isEqual(value, comparing) {
        const first = this.date(value);
        const second = this.date(comparing);
        if (first === second) {
            return true;
        }
        if (!first || !second) {
            return false;
        }
        return first.equals(second);
    }
    isSameHour(value, comparing) {
        return this.isSameDay(value, comparing) && value.hour == comparing.hour;
    }
    startOfDay(value) {
        return value.toPlainDate().toPlainDateTime({ hour: 0 });
    }
    endOfDay(value) {
        return value.toPlainDate().toPlainDateTime({ hour: 23, minute: 59, second: 59 });
    }
    getHours(value) {
        return value.hour;
    }
    setHours(value, count) {
        return value.with({ hour: count });
    }
    getMinutes(value) {
        return value.minute;
    }
    setMinutes(value, count) {
        return value.with({ minute: count });
    }
    getSeconds(value) {
        return value.second;
    }
    setSeconds(value, count) {
        return value.with({ second: count });
    }
    setMonth(value, count) {
        return value.with({ month: count });
    }
    setYear(value, count) {
        return value.with({ year: count });
    }
    mergeDateAndTime(date, time) {
        return date.toPlainDate().toPlainDateTime(time);
    }
    addSeconds(value, count) {
        return value.add({ seconds: count });
    }
    addMinutes(value, count) {
        return value.add({ minutes: count });
    }
    addHours(value, count) {
        return value.add({ hours: count });
    }
    addDays(value, count) {
        return value.add({ days: count });
    }
    addWeeks(value, count) {
        return value.add({ weeks: count });
    }
    addMonths(value, count) {
        return value.add({ months: count });
    }
}
//# sourceMappingURL=PlainDateTimeAdapter.js.map